import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import IntakeForm from './pages/IntakeForm';
import CaseSearch from './pages/CaseSearch';
import CalendarPage from './pages/CalendarPage';
import CaseDetails from './pages/CaseDetails';
import EditCase from './pages/EditCase';
import Navbar from './components/Navbar';
import Settings from './pages/Settings';
import './App.css';

import { Authenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import { useAppContext } from './context/AppContext';

function App() {
  const { mfaEnabled } = useAppContext();
  const requireMFASetup = true; // ✅ Toggle for enforced MFA setup

  return (
    <Authenticator hideSignUp>
      {({ signOut, user }) => (
        <Router>
          {/* ✅ Only show Navbar if MFA is complete */}
          {!requireMFASetup || mfaEnabled ? (
            <div className="no-print">
              <Navbar signOut={signOut} user={user} />
            </div>
          ) : null}

          <div className="app-container">
            <Routes>
              {/* ✅ Redirect to settings if MFA not done */}
              <Route path="/" element={requireMFASetup && !mfaEnabled ? <Settings /> : <Dashboard />} />
              <Route path="/intake" element={requireMFASetup && !mfaEnabled ? <Settings /> : <IntakeForm />} />
              <Route path="/search" element={requireMFASetup && !mfaEnabled ? <Settings /> : <CaseSearch />} />
              <Route path="/calendar" element={requireMFASetup && !mfaEnabled ? <Settings /> : <CalendarPage />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/case/:id" element={requireMFASetup && !mfaEnabled ? <Settings /> : <CaseDetails />} />
              <Route path="/case/:id/edit" element={requireMFASetup && !mfaEnabled ? <Settings /> : <EditCase />} />
            </Routes>
          </div>
        </Router>
      )}
    </Authenticator>
  );
}

export default App;
